import { createVNode, render } from 'vue'
import LoadingComponent from './loading.vue'

let loadingContainer = null
let loadingWrapper = null
let visibleCount = 0

const ensureContainer = () => {
  if (!loadingContainer) {
    loadingContainer = document.createElement('div')
    loadingContainer.setAttribute('class', 'xy-loading-container')
    document.body.appendChild(loadingContainer)
  }
  return loadingContainer
}

const show = (options = {}) => {
  visibleCount++
  if (visibleCount > 1) return

  const container = ensureContainer()
  loadingWrapper = document.createElement('div')
  loadingWrapper.setAttribute('class', 'xy-loading-wrapper')
  container.appendChild(loadingWrapper)

  const vnode = createVNode(LoadingComponent, {
    message: options.message || ''
  })
  render(vnode, loadingWrapper)
}

const hide = () => {
  if (visibleCount <= 0) return

  visibleCount--
  if (visibleCount > 0 || !loadingWrapper) return

  render(null, loadingWrapper)
  if (loadingContainer?.contains(loadingWrapper)) {
    loadingContainer.removeChild(loadingWrapper)
  }
  loadingWrapper = null
}

const Loading = {
  show,
  hide
}

export default Loading
